import {TOption} from './TOption'

export const NEWS_FLAGS: TOption[] = [
  {value: '0', label: 'Not-active'},
  {value: '1', label: 'Active'},
]
